/*
 *   File : tab.js
 *   Author : https://evoqins.com
 *   Description : tab component
 *   Integrations : NA
 *   Version : 1.0.1
*/

// packages
import React from 'react';

// components
import CustomTooltip from './custom-tooltip';

// styles
import style from '../../Style/Component/tab.module.scss';

const CustomTab = (props) => {

    return (
        <div className={`d-flex align-items-center ${props.flexGap ? props.flexGap : "gap-3"}`}>
            {props.data.map((item, index) => {
                const isSelected = item.id === props.selectedTab;
                const isDisabled = item.disabled === true;

                return (
                    <>
                        {props.type === 2 ?
                            <div key={index} className={`d-flex position-relative align-items-center justify-content-center`}>
                                <div className={`${isSelected ? "e-bg-blue-violet e-text-white pe-none" : isDisabled ? `pe-none ${style.e_disabled_tab} e-bg-lavender-light e-text-dark-gray` : "cursor-pointer e-bg-lavender-light e-text-dark-gray"} ${props.className} border-radius-8 e-font-weight-400 e-font-16 line-height-20px e-primary-font py-2 padding-24px-lr `}
                                    onClick={() => !isDisabled && props.handleClick(item.id, item?.type)} >
                                    {item.label}
                                </div>
                            </div>
                            :
                            <div key={index} className={`d-flex position-relative align-items-center justify-content-center`}>
                                <div
                                    className={props.customTab
                                        ? `${style.custom_tab} e-letter-7 e-border-1px-white border-radius-18 padding-6px-tb padding-8px-lr e-primary-font line-height-16px e-font-12 e-font-weight-400 e-text-white e-tab-box-shadow transition
                                   ${isSelected ? `e-text-black e-opacity-1  ${style.e_custom_active_tabs}` : isDisabled ? `${style.e_tabs} ${style.e_disabled_tab} pe-none` : `${style.e_tabs} e-cursor-pointer`}`
                                        : ` e-font-weight-400 e-font-16 line-height-18px e-primary-font padding-6px-tb padding-8px-lr e-text-chinese-black ${isSelected ? `${style.e_active_tabs} pe-none` : isDisabled ? `${style.e_tabs} ${style.e_disabled_tab} pe-none` : `${style.e_tabs} e-cursor-pointer`}`
                                    }
                                    onClick={() => !isDisabled && props.handleClick(item.id, item?.type)}
                                >
                                    {item.label}


                                </div>
                                {
                                    item.id !== props.selectedTab && item.tooltip === true &&
                                    <CustomTooltip content={item.tooltipContent}
                                        id={`tooltip-${item.id}`}
                                    />
                                }

                            </div>
                        }
                    </>
                );
            })}
        </div>
    );
}

export default CustomTab;

CustomTab.defaultProps = {
    tooltip: true
};